module.exports = __webpack_public_path__ + "static/media/131.60874260.png";